import React, { useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core'
import { NotificationsNone as NotifyIcon } from '@material-ui/icons'

import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'

const NotifyDialog = ({
  open,
  courseId,
  enrollmentIds,
  onClose,
  onSuccess,
}) => {
  const snackbar = useSnackbar()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await service.dponet.trainingEnrollment.batchNotify({
        courseId,
        enrollmentIds,
        message,
      })
      setMessage('')
      onSuccess()
    } catch {
      snackbar.open({
        message: 'Erro ao enviar notificação.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setMessage('')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <NotifyIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
        Notificar colaborador
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Este e-mail envia o link de acesso e informações adicionais sobre o
          curso para{' '}
          {enrollmentIds.length > 1
            ? `${enrollmentIds.length} alunos`
            : 'o aluno'}
          .
        </Typography>
        <TextField
          label="Mensagem ao colaborador"
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          style={{ marginTop: 16 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default NotifyDialog
